export default [{
        url: { name: 'home'},
        name: "Dashboard",
        slug: "home",
        icon: "HomeIcon",
    },
    {
        header: 'Αναφορες',
        icon: 'PackageIcon',
        i18n: 'Reports',
        items: [{
                url: { name: 'reports-table' },
                name: 'Πίνακας',
                slug: 'reports-table',
                i18n: 'Πίνακας',
                icon: "PieChartIcon",
            },
            {
                url: { name: 'reports-market-places' },
                name: 'Λίστα',
                slug: 'reports-market-places',
                i18n: 'Πίνακας',
                icon: "PieChartIcon",
            }
        ]
    },
    {
        header: 'ΠΡΟΪΟΝΤΑ',
        icon: 'PackageIcon',
        i18n: 'Apps',
        items: [{
                url: { name: 'products-list' },
                name: "Προϊόντα",
                slug: "products-list",
                icon: "ShoppingCartIcon",
                i18n: "Προϊόντα",
            },
            {
                url: { name: 'total-urls' },
                name: "Σύνδεσμοι",
                slug: "total-urls",
                icon: "LinkIcon",
                i18n: "Σύνδεσμοι",
            },
            {
                url: { name: 'shops' },
                name: "Καταστήματα",
                slug: "shops",
                icon: "SearchIcon",
                i18n: "Καταστήματα",
            },
            {
                url: { name: 'settings-categories' },
                name: 'Κατηγορίες',
                slug: 'dashboard-ecommerce',
                i18n: 'Κατηγορίες',
                icon: "LayoutIcon",
            },
            {
                url: { name: 'groups' },
                name: "Ομάδες",
                slug: "groups",
                icon: "UsersIcon",
                i18n: "Ομάδες",
            },
            {
                url: { name: 'eshops' },
                name: "Πηγές",
                slug: "eshops",
                icon: "LinkIcon",
                i18n: "Πηγές",
            },
        ]
    },
    {
        header: 'Ρυθμισεις',
        icon: 'PackageIcon',
        i18n: 'Settings',
        items: [
            // {
            //     url: '/settings/sources',
            //     name: 'Πηγές',
            //     slug: 'dashboard-analytics',
            //     i18n: 'Πηγές',
            //     icon: "ListIcon",
            // },
            {
                url : { name: 'settings-users'},
                name: 'Χρήστες',
                slug: 'dashboard-ecommerce',
                i18n: 'Χρήστες',
                icon: "UserIcon",
            },
            {
                url: { name: 'settings-sync-xls' },
                name: 'Εισαγωγή προϊόντων',
                slug: 'settings-sync-xls',
                i18n: 'Εισαγωγή προϊόντων',
                icon: "DownloadIcon",
            },
            {
                url: { name: 'settings-import-links' },
                name: 'Εισαγωγή συνδέσμων',
                slug: 'settings-import-links',
                i18n: 'Εισαγωγή συνδέσμων',
                icon: "LayersIcon",
            },

            {
                url: { name: 'settings-import-products-n-links' },
                name: 'Παράμετροι πεδίων',
                slug: 'settings-import-products-n-links',
                i18n: 'Παράμετροι πεδίων',
                icon: "SettingsIcon",
            },
            {
                url: { name: 'settings-schedule'},
                name: 'Προγραμματισμός',
                slug: 'settings-schedule',
                i18n: 'Προγραμματισμός',
                icon: "CalendarIcon",
            },
            {
                url: { name: 'settings-dynamic-pricing'},
                name: 'Dynamic Pricing',
                slug: 'settings-dynamic-pricing',
                i18n: 'Dynamic Pricing',
                icon: "BookmarkIcon",
            }
        ]
    },
]
